import OrderApi from 'api/order'

const ORDER_SET_CHECKID = 'ORDER_SET_CHECKID'
const CHECK_STATE_INTERVAL = 2000

// initial state
const state = {
  checks: {}
}

const mutations = {
  [ORDER_SET_CHECKID](state, { id, checkID }) {
    state.checks[id] = checkID
  }
}

// actions
const actions = {
  // get list of projects income
  cancelCheckState({ state, commit }, id) {
    let cid = state.checks[id]
    if (cid) {
      window.clearTimeout(cid)
      commit(ORDER_SET_CHECKID, { id: id, checkID: null })
    }
    Promise.resolve()
  },
  checkState({ state, dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      let check = () => {
        OrderApi.state(id).then(res => {
          let state = res.data.state

          if (state === 'completed') {
            // finished check
            // dispatch refresh for any order completed
            dispatch('refresh', null, { root: true })
            dispatch('cancelCheckState', id)
            resolve()
          } else {
            commit(ORDER_SET_CHECKID, { id: id, checkID: window.setTimeout(check, CHECK_STATE_INTERVAL) })
          }
        }).catch(err => {
          reject(err)
        })
      }

      dispatch('cancelCheckState', id).then(check)
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js